import { Button } from '@kcd/design-system';

import { getResizeImage } from '~/components/Image';
import { TrackClick } from '~/components/TrackEvent';
import { CAMPAIGN_ROUTER } from '~/constants/router';
import type { OAISchema } from '~/types/openapi';
import { openModal, openPageModal } from '~/utils/mobileApp';

import { CampaignInfo } from '../../../../domains/campaign/components/CampaignInfo';

type Props = {
  campaign: OAISchema['CampaignFrontListItemResponse'];
  isToday: boolean;
};

export function HomeCampaignEventTypeSection({ campaign, isToday }: Props) {
  return (
    <TrackClick
      name="clicked listItem in 마켓"
      properties={{
        placementName: '마켓알뜰톡톡',
        campaignDate: campaign.exposureAtKst,
        name: campaign.code,
        path: window.location.pathname,
        detailedPlaceMent: campaign.code,
      }}
    >
      <div className="flex flex-col gap-12 rounded-[24px] border border-solid border-02 px-20 py-16">
        <CampaignInfo campaign={campaign} isToday={isToday} />
        <img
          src={getResizeImage({
            src: campaign.thumbnail || '',
            width: 768,
          })}
          alt="캠페인"
          className="rounded-16"
        />
        <Button
          variant="outline"
          size="md"
          className="w-full"
          onClick={() => {
            if (campaign.landingUrl) {
              openModal({
                url: campaign.landingUrl,
              });
              return;
            }

            openPageModal(CAMPAIGN_ROUTER.campaignDetail(campaign.code));
          }}
        >
          이벤트 보러가기
        </Button>
      </div>
    </TrackClick>
  );
}
